export const GoogleMapApiConfig = 'AIzaSyCXX-i-oSvZVrkRE5mgx_V9BGoqmW1vsK0';